// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import ReportsList from "../../../components/ReportsList.js";

const ReportListing = () => {
  return (
    <>
      <Header
        title="Reports"
        description="This is your report list. You manage your reports here."
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <ReportsList />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ReportListing;
